import { render, staticRenderFns } from "./recuperar.vue?vue&type=template&id=b884c270&scoped=true&"
import script from "./recuperar.vue?vue&type=script&lang=js&"
export * from "./recuperar.vue?vue&type=script&lang=js&"
import style0 from "./recuperar.vue?vue&type=style&index=0&id=b884c270&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b884c270",
  null
  
)

export default component.exports